import { AsyncResult, useBitbucketWorkspaces } from '@atlassiansox/bxpkit-core';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { BitbucketWorkspace } from '../model';

/**
 * Hook that provides bitbucket workspace info relevant to signup
 */

export const getBitbucketWorkspaces = (makeRequest: boolean) => {
  const [bbWorkspaces, setBbWorkspaces] = useState<any>([]);
  const bbWorkspacesAsync = useBitbucketWorkspaces({ makeRequest });

  useEffect(() => {
    if (!bbWorkspacesAsync || AsyncResult.isPending(bbWorkspacesAsync)) {
      return;
    }

    const bbData = bbWorkspacesAsync.catch(() => null).value;
    if (bbData) {
      // analytics.trackBbSignupPerf();
      // TODO: consider Pagination
      const { values } = bbData;
      if (values) {
        // remove any non admin workspace
        const purifiedData = filter(
          values,
          (workspace: BitbucketWorkspace) => workspace.permission === 'owner'
        );
        setBbWorkspaces(purifiedData);
      }
    }
  }, [bbWorkspacesAsync]);

  return bbWorkspaces;
};
